import React, { Fragment } from "react";
import * as MUI from "@mui/material";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { Link } from "react-router-dom";

export default function TermsAndConditionsSrb() {
  const { mode } = React.useContext(ThemeContext);
  return (
    <Fragment>
      <MUI.Typography variant="h3">Uslovi korišćenja</MUI.Typography>
      <MUI.Divider />
      <Fragment>
        <MUI.Stack spacing={4}>
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h4">
              Politika zaštite podataka
            </MUI.Typography>
            <MUI.Typography variant="h5">
              {String("Uvod").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Posvećeni smo zaštiti privatnosti i bezbednosti vaših ličnih
              podataka u skladu sa Opštom uredbom o zaštiti podataka (GDPR) (EU
              Uredba 2016/679). Ova politika objašnjava kako prikupljamo,
              obrađujemo i čuvamo vaše lične podatke prilikom korišćenja
              naše platforme za upravljanje veterinarskim klinikama. Naš cilj je
              da osiguramo transparentnost i poverenje, uz poštovanje zakona o
              zaštiti podataka, kao i da odgovorno i bezbedno rukujemo vašim podacima.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Bezbednosne mere").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Koristimo bezbednosne mere industrijskog standarda kako bismo
              zaštitili vaše podatke, uključujući enkripciju, redovne
              bezbednosne provere i stroge kontrole pristupa kako bismo
              sprečili neovlašćeni pristup.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("PRISTUP WEB STRANICI").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Kada otvorite našu veb stranicu, Vaš veb pregledač će preneti
              određene podatke na naš veb server. Prenos podataka se vrši
              iz tehničkih razloga, kako bismo Vam mogli učiniti dostupnim
              zatražene informacije. Kako bismo Vam olakšali pristup veb stranici,
              prikupljaju se, čuvaju na kratko vreme i koriste sledeći
              podaci:
            </MUI.Typography>
            <MUI.List sx={{ listStyleType: "disc" }}>
              <MUI.ListItem sx={{ display: "list-item" }}>
                IP adresa
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list-item" }}>
                Datum i vreme pristupa
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list-item" }}>
                Razlika u vremenskoj zoni u odnosu na srednje vreme po
                Griniču (GMT)
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Sadržaj zahteva (specifična stranica)
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Status pristupa/HTTP statusni kod
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Količina prenetih podataka
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Veb stranica koja zahteva pristup
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Veb pregledač, podešavanja jezika, verzija pregledača, operativni
                sistem i površina
              </MUI.ListItem>
            </MUI.List>
            <MUI.Typography>
              Nadalje, kako bismo zaštitili naše legitimne interese, takve
              podatke čuvamo na ograničeno vreme kako bismo mogli
              da započnemo sa praćenjem ličnih podataka u slučaju ili pokušaju
              neovlašćenog pristupa našim serverima (član 6(1)(f) Opšte
              uredbe o zaštiti podataka).
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Koje podatke prikupljamo").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Prikupljamo sledeće vrste podataka kako bismo pružili naše
                usluge:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Lični podaci: Ime, broj telefona, adresa e-pošte i ostali
                  kontakt podaci.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Podaci o kućnim ljubimcima: Ime kućnog ljubimca, vrsta,
                  rasa, starost i zdravstveni podaci (npr. datumi vakcinacije,
                  tretmani).
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Podaci o nalogu: Korisnička imena, lozinke i podešavanja povezana
                  sa vašim nalogom.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Ovi podaci nam omogućavaju pružanje usluga poput zakazivanja
                termina, upravljanja zdravstvenim kartonima kućnih ljubimaca i
                efikasne komunikacije između vlasnika ljubimaca i
                veterinarskog osoblja.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Kako koristimo vaše podatke").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Vaše podatke obrađujemo u sledeće svrhe:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Olakšavanje zakazivanja termina i rezervacija.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Čuvanje i upravljanje medicinskim kartonima kućnih ljubimaca
                  za kontinuirano lečenje.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Omogućavanje tačne komunikacije između vlasnika kućnih
                  ljubimaca i veterinarskog osoblja.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Podrška za interne alate za upravljanje poslovanjem klinika.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Vaše podatke obrađujemo isključivo radi pružanja i poboljšanja
                naših usluga.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Tko ima pristup vašim podacima").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Pristup vašim ličnim podacima ograničen je na ovlašćeno
                osoblje:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Zaposleni u veterinarskim klinikama: Zaposleni u klinici koju
                  izaberete za lečenje vašeg kućnog ljubimca. U slučaju
                  promene klinike, nova klinika ima pristup samo novim
                  podacima, dok prethodna klinika zadržava istorijske podatke o
                  pruženim uslugama.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Administratori aplikacije: Ovlašćeni zaposleni naše kompanije
                  odgovorni za održavanje i poboljšanje platforme.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Ne delimo vaše lične podatke sa trećim stranama osim ako to
                zakon zahteva ili ako integrišemo spoljne usluge (npr. POS
                sisteme) uz vaš pristanak.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Vaša prava prema GDPR-u").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Imate sledeća prava u vezi sa vašim podacima:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Pristup: Pregled svih ličnih podataka koje imamo o vama.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Ispravka: Ispravka netačnih podataka.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Brisanje: Zahtev za brisanjem vaših podataka, osim zakonski
                  potrebnih zapisa.{" "}
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Prenos podataka: Zahtev za kopiju vaših podataka u
                  strukturiranom, mašinski čitljivom formatu.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Povlačenje pristanka: Povlačenje pristanka za obradu podataka
                  u bilo kom trenutku.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Za ostvarivanje ovih prava kontaktirajte nas na:
                <Link
                  color="inherit"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = `mailto:${"info@kilobyte.hr"}`;
                  }}
                >
                  info@kilobyte.hr
                </Link>
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Period čuvanja podataka").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Vaše podatke čuvamo sve dok je vaš nalog aktivan. Ako izbrišete
                svoj nalog, brišemo sve povezane lične podatke osim ako je
                zakonski ili operativno potrebno zadržati određene podatke. Na
                primer, tretmani povezani sa vašim kućnim ljubimcem ostaju
                vidljivi klinici koja je pružila uslugu.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("PRIMENA KOLAČIĆA").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                CENTAR ZA ZAŠTITU NA RADU koristi alate pomoću kojih analizira
                korišćenje internet portala CENTAR ZA ZAŠTITU NA RADU i
                pomoću kojih možemo prikupiti određene informacije o vama i
                time stičemo saznanja o potrebama svojih posetilaca i/ili
                korisnika čija je svrha poboljšanje kvaliteta naše ponude. S
                tim u vezi koriste se i takozvani kolačići, kao i neki drugi
                alati.
              </MUI.Typography>
              <MUI.Typography>
                Korisnik i/ili posetilac može putem odgovarajućih podešavanja na
                svom računaru, pomoću podešavanja pregledača koji koristi,
                odbiti ili izbrisati kolačiće. Međutim, to može dovesti do toga
                da se neke funkcije internet portala CENTAR ZA ZAŠTITU NA
                RADU više ne mogu u potpunosti koristiti.
              </MUI.Typography>
              <MUI.Typography>
                Navedeni alati prikupljaju i čuvaju neke tehničke podatke,
                uključujući IP adresu korisnika i/ili posetioca.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Usluge trećih strana i globalna upotreba").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Iako trenutno poslujemo unutar EU, naša platforma se zasniva na
              oblaku (cloud-u), a podaci se mogu obrađivati na serverima u drugim
              zemljama. Osiguravamo da svi međunarodni prenosi podataka budu u
              skladu sa GDPR standardima. Ako integrišemo usluge trećih strana
              (npr. POS ili analitiku), osiguravamo da su ti dobavljači usluga
              usklađeni sa GDPR-om i da zadovoljavaju naše stroge standarde
              privatnosti.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("LINKOVI NA DRUGE VEB STRANICE").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Ova veb stranica može sadržati linkove na druge veb stranice
              koje pripadaju drugoj organizaciji koja ima svoja posebna pravila
              privatnosti, pa skrećemo pažnju da se upoznate sa njihovim uslovima
              korišćenja i pravilima privatnosti pre nego što im dostavite bilo
              kakve lične podatke, jer CENTAR ZA ZAŠTITU NA RADU ne preuzima
              odgovornost za te veb stranice ili organizacije koje njima
              upravljaju.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Ažuriranja ove politike").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Ovu politiku možemo povremeno ažurirati kako bismo ispratili
              promene u zakonskim zahtevima ili našim uslugama. Značajne
              promene biće komunicirane putem e-pošte ili unutar aplikacije
              pre nego što stupe na snagu.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Kontakt podaci".toUpperCase())}
            </MUI.Typography>
            <MUI.Typography>
              Ako imate pitanja, zabrinutosti ili pritužbe u vezi sa ovom
              politikom, možete nas kontaktirati na: Email:{" "}
              <Link
                color="inherit"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = `mailto:${"info@kilobyte.hr"}`;
                }}
              >
                info@kilobyte.hr
              </Link>
            </MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>
      </Fragment>
    </Fragment>
  );
}